module.exports = __webpack_public_path__ + "img/unlink-confirmation-icon.343cb538.png";